import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  devolucion_proveedor: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};